<div #container
  [ngClass]="{'qualify-mood': qualification === true,
  'register-mood':register === true  ,
  'status-editor' : statusEditor === true ,
  'status-editorT' : statusEditorTest === true ,
  'accountInfo-mood' : accountInfo === true,
  'exsep_profile_status': exsepStatusProfile === true }  
  ">
  <ng-select
    [appendTo]="'div'"
    class="single-select"
    (change)="clickMenu($event)"
    #Selecter [(ngModel)]="valueSelected"
    (focus)="setStatus(status)"
    >
    @for (value of values; track value) {
      <ng-option  [value]="value.id"  [ngStyle]="{'background-color': value.color}">
        <div class="option-item" [ngStyle]="{'background': value.color}">{{value.name}}</div>
      </ng-option>
    }
  </ng-select>
</div>
